<template>
	<div>
		<a-modal
			:bodyStyle="{ padding: 0 }"
			:mask="true"
			width="80%"
			wrapClassName="attachClass"
			:dialogStyle="{}"
			dialogClass="dialogClass"
			:maskStyle="{}"
			:title="
				(h) => {
					return h('div', [h('span', '上传 | 查看报关单 / 放行单')]);
				}
			"
			:visible="visible_upload_modal"
			:confirm-loading="confirmLoading_box"
			@cancel="closeUploadModal"
		>
			<template>
				<div style="textAlign:left;lineHeight:3rem;">
					<h3>
						提单号:<span style="marginLeft:20px;">{{ blNumber }}</span>
					</h3>
				</div>
				<template>
					<div class="clearfix">
						<a-upload-dragger
							:multiple="true"
							:customRequest="uploadFilesGetUrl"
							@change="change"
							:beforeUpload="beforeUpload"
							:file-list="fileList"
							:remove="removeAttachment"
						>
							<p class="ant-upload-drag-icon">
								<a-icon type="inbox" />
							</p>
							<p class="ant-upload-text">
								将文件拖拽到此处,或点击上传
							</p>
							<h4 class="ant-upload-hint">
								文件类型支持: .rar .zip .doc .pdf ...
							</h4>
							<h4 class="ant-upload-hint">
								文件最大不能超过10M
							</h4>
						</a-upload-dragger>
					</div>
				</template>
			</template>

			<template slot="footer" class="footer_paiche">
				<a-button
					key="submit"
					type="primary"
					:loading="confirmLoading_upload"
					@click="uploadFiles"
					class="avatar-uploader"
				>
					上传
				</a-button>
				<a-button key="back" @click="closeUploadModal">
					取消
				</a-button>
			</template>
		</a-modal>
	</div>
</template>

<script>
// 引入上传报关附件接口
import {
	uploadDeclarationAttachment,
	queryDeclarationAttachment,
} from "../../api/business-dispatch";
import { searchReqParam } from "../../utils/searchReqParam";
import { compressImg } from "../../utils/compressImg";
import { uploadSeals } from "../../api/business-dispatch";

export default {
	name: "file-upload",
	props: {
		selectedRows: {
			type: Array,
			default() {
				return [];
			},
		},
		declarationResult: {
			type: Object,
			default() {
				return {};
			},
		},
	},
	components: {},
	data() {
		return {
			req: searchReqParam(),
			visible_upload_modal: false,
			confirmLoading_box: false,
			confirmLoading_upload: false,
			blNumber: "",
			fileList: [],
			attachmentList: [],
			attach: [],
		};
	},
	computed: {},
	mounted() {},
	methods: {
		showUploadAttachment(scope) {
			console.log(scope);
			this.blNumber = scope.attach.blNumber;
			let params = {
				attachmentType: "RELEASE_PERMIT",
				declarationId: "",
			};
			// 此处containerId 须使用报关 id
			params.declarationId = scope.attach.containerId;
			this.req.params = params;

			queryDeclarationAttachment(this.req).then((res) => {
				// this.attach = [];
				let resData = JSON.parse(res.data).data;
				console.log(resData);
				// if (resData.length == 0) {
				// 	this.$message.warn("暂无附件信息");
				// 	return;
				// }
				this.attach = this.getAttachments(resData);
				this.fileList = [...this.fileList, ...this.attach];
				console.log(this.attach, this.fileList);
				this.visible_upload_modal = true;
			});
		},
		// 对附件进行封装
		getAttachments(queryDeclarationAttachment) {
			let attachments = [];
			queryDeclarationAttachment.forEach((element, index) => {
				console.log(
					element.url.substr(element.url.lastIndexOf("."), element.url.length)
				);
				console.log(element);
				// let fileType = element.url.substr(
				// 	element.url.lastIndexOf(".") + 1,
				// 	element.url.length
				// );
				let name = element.url.substr(
					element.url.lastIndexOf("/") + 1,
					element.url.length
				);
				attachments.push({
					uid: Date.now() + index, // 注意，这个uid一定不能少，否则上传失败
					// type: fileType,
					status: "done",
					// fileType: element.fileType,
					url: element.url,
					name:
						!element.fileName ||
						element.fileName == null ||
						element.fileName == ""
							? name
							: element.fileName,
					imgUrl: element.url,
				});

				// name: options.file.name,
				// status: "done",
				// url: result.data.filePaths[0], // url 是展示在页面上的绝对链接
				// imgUrl: result.data.filePaths[0], // imgUrl 是存到 db 里的相对链接
			});
			//  对附件排序
			// attachments.sort((a, b) => {
			// 	return a.type > b.type ? 1 : -1;
			// });
			console.log("attachments ===== ", attachments);
			return attachments;
		},
		// 关闭上传附件窗口
		closeUploadModal() {
			this.attach = [];
			this.fileList = [];
			this.visible_upload_modal = false;
		},
		// 删除附件
		removeAttachment(file) {
			console.log(file, this.fileList);
			let index = this.fileList.indexOf(file);
			console.log(index);
			this.fileList.splice(index, 1);
			console.log(this.fileList);
		},
		// 上传附件之前压缩文件
		beforeUpload(file) {
			return new Promise((resolve) => {
				// 限定文件类型 , reject
				// if (!file.type.includes("image")) {
				// 	this.$message.warning("请上传图片");
				// 	reject(new Error("请上传图片"));
				// 	return;
				// }
				console.log(file);
				// 只对图片进行压缩
				if (file.type.includes("image")) {
					compressImg(file).then((res) => {
						console.log(res);
						resolve(res);
					});
				} else {
					resolve(file);
				}
			});
		},
		// 请求 upload 接口生成url
		uploadFilesGetUrl(options) {
			console.log("options === ", options);
			// 封装请求数据
			const param = new FormData();
			const meta = {
				code: "tms-client",
				client: "PC",
				tag: "tms-client",
				time: Date.now(),
			};
			const params = {
				bizType: "seals_fh",
			};
			for (let key in meta) {
				param.append(`meta.${key}`, meta[key]);
			}
			for (let key in params) {
				param.append(`params.${key}`, params[key]);
			}
			param.append("params.files", options.file);
			let that = this;
			uploadSeals(param).then((res) => {
				// console.log(JSON.parse(res.data));
				let result = JSON.parse(res.data);
				if (result.code == "0") {
					// 成功
					// result.data
					const imgItem = {
						uid: Date.now(), // 注意，这个uid一定不能少，否则上传失败
						name: options.file.name,
						status: "done",
						url: result.data.filePaths[0], // url 是展示在页面上的绝对链接
						imgUrl: result.data.filePaths[0], // imgUrl 是存到 db 里的相对链接
						// response: '{"status": "success"}',
					};
					console.log(imgItem);
					// that.fileList_fh = [imgItem];
					setTimeout(() => {
						that.fileList.push(imgItem);
						console.log(that.attach, that.fileList);
					}, 1000);
				} else {
					// 失败提示信息
					this.$message.error(result.msg);
				}
			});
		},
		// 确认上传附件
		uploadFiles() {
			// 封装请求数据
			let params = {};

			params.currentUserId = "";
			// 报关ID
			params.declarationId = this.declarationResult.id;
			console.log(this.fileList);
			// 附件信息
			if (this.fileList.length < 1) {
				this.$message.warn("请先选择文件上传");
				return;
			}
			params.files = [];
			this.fileList.forEach((ele) => {
				params.files.push({
					attachmentId: "",
					fileType: "RELEASE_PERMIT",
					url: ele.url,
					fileName: ele.name,
				});
			});
			// // 附件信息
			// params.files = [{ attachmentId: "", fileType: "", url: "" }];
			console.log(params.files);
			this.req.params = params;

			this.confirmLoading_box = true;
			console.log(this.req);
			uploadDeclarationAttachment(this.req).then((res) => {
				// console.log(JSON.parse(res.data));
				let result = JSON.parse(res.data);
				if (result.code == "0") {
					// 成功提示信息
					this.$message.success(result.msg);
					// 重置
					this.visible_box = false;
					this.form_upload = {
						containerNumber: "",
						containerSeal: "",
						files: [],
					};
					this.fileList = [];
					this.confirmLoading_box = false;
					// 通知父单元成功消息
					this.$emit("success", result.msg);
					this.visible_upload_modal = false;
				} else {
					// 失败提示信息
					this.$message.error(result.msg);
				}
			});
		},

		change(options) {
			console.log(options);
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .ant-modal {
	width: 50% !important;
	.ant-modal-body {
		padding: 15px !important;
	}
}
@media screen and (max-width: 768px) {
	/deep/ .ant-modal-content {
		width: 1040px;
	}
}
</style>
